export default "__VITE_ASSET__DBsB4uVi__"